import { render, staticRenderFns } from "./CharactersArchetypes.vue?vue&type=template&id=724e61a0&lang=pug&"
import script from "./CharactersArchetypes.vue?vue&type=script&lang=ts&"
export * from "./CharactersArchetypes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports